export default __webpack_public_path__ + "logo-kahoot.png?939e39da062feecb547fb5eab94ecc02";